import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

export const buttonRecipe = defineStyleConfig({
  baseStyle: {
    borderRadius: 'xl',
    fontWeight: '700',
    borderStyle: 'solid',
    w: 'max',
  },
  sizes: {
    sm: {
      h: '40px',
      px: '4',
      py: '1.5',
      fontSize: 'sm',
      borderWidth: '2px',
    },
    md: {
      h: '44px',
      px: '35px',
      py: '14px',
      fontSize: 'md',
      borderWidth: '2px',
    },
    lg: {
      h: '48px',
      px: '35px',
      py: '3',
      fontSize: 'lg',
      borderWidth: '2px',
    },
    xl: {
      h: '60px',
      px: '44px',
      py: '4',
      fontSize: '20px',
      borderWidth: '2px',
      lineHeight: '26px',
    },
    xxl: {
      h: '75px',
      px: '35px',
      py: '12px',
      fontSize: 'xl',
      borderWidth: '2px',
    },
  },
  variants: {
    solid: defineStyle(({ colorScheme }) =>
      colorScheme === 'secondary'
        ? {
            color: 'primary.500',
            border: 'none',
            bg: `${colorScheme}.300`,

            _hover: {
              bg: `${colorScheme}.500`,
            },
            _active: {
              bg: `${colorScheme}.600`,
            },
          }
        : {
            color: 'white',
            border: 'none',
          }
    ),
    unstyled: defineStyle(() => ({
      paddingInline: 4,
      lineHeight: 1.2,
      border: 'none',
    })),
    ghost: defineStyle(({ colorScheme }) => ({
      border: 'none',
      _hover: { bg: `${colorScheme}.50` },
      _active: { bg: `${colorScheme}.100` },
    })),
    outline: defineStyle(({ colorScheme }) =>
      colorScheme === 'gray'
        ? {
            color: `${colorScheme}.800`,
            borderColor: `${colorScheme}.800`,
            _hover: {
              borderColor: `${colorScheme}.800`,
              color: `${colorScheme}.800`,
              bg: `${colorScheme}.300`,
            },
            _active: {
              borderColor: 'transparent',
              color: 'white',
              bg: `${colorScheme}.700`,
            },
          }
        : {
            color: `${colorScheme}.600`,
            borderColor: `${colorScheme}.600`,
            _hover: {
              borderColor: `${colorScheme}.600`,
              color: `${colorScheme}.600`,
              bg: `${colorScheme}.50`,
            },
            _active: {
              bg: `${colorScheme}.100`,
            },
          }
    ),
    link: defineStyle(({ colorScheme }) => ({
      textDecor: 'underline',
      textUnderlineOffset: 6,
      border: 'none',
      _hover: {
        color: `${colorScheme}.600`,
        textDecor: 'underline',
        textUnderlineOffset: 6,
      },
    })),
  },
  defaultProps: {
    variant: 'solid',
    size: 'md',
    colorScheme: 'primary',
  },
});
